import type { MutationTree } from 'vuex';
import type { PageType, UnpublishState } from '../type';

import { canSetDefaultPageTypes } from '../utils/helper';
import { mutationTypes } from './types';

const mutations: MutationTree<UnpublishState> = {
  [mutationTypes.STORE_PUBLISHED_PAGE](state: UnpublishState, payload: { publishedPage: PageType[]}) {
    state.publishedPage = payload.publishedPage;
    state.isFetched = true;
    state.isLoading = false;

    return state;
  },
  [mutationTypes.ADD_PAGE](state: UnpublishState, payload: { pageId: number }) {
    state.unpublishList = [...new Set([...state.unpublishList, payload.pageId])];

    return state;
  },
  [mutationTypes.REMOVE_PAGE](state: UnpublishState, payload: { pageId: number }) {
    state.unpublishList = state.unpublishList.filter(id => id !== payload.pageId );

    return state;
  },
  [mutationTypes.SELECT_ALL_PAGE](state: UnpublishState) {
    state.publishedPage.forEach(page => {
      if (!page.isInCampaign && !(page.isDefault && canSetDefaultPageTypes(page.type))) {
        state.unpublishList.push(page.id);
      }
    });
    state.unpublishList = [...new Set(state.unpublishList)]

    return state;
  },
  [mutationTypes.REMOVE_ALL_PAGE](state: UnpublishState) {
    state.unpublishList = [];

    return state;
  },
  [mutationTypes.SET_IS_LOADING](state: UnpublishState, value: boolean) {
    state.isLoading = value;

    return state;
  },
  [mutationTypes.SET_IS_OPEN_MODAL](state: UnpublishState, value: boolean) {
    state.isOpenPopup = value;

    return state;
  },
  [mutationTypes.RESET_UNPUBLISH_DATA](state: UnpublishState) {
    state.publishedPage = state.publishedPage.filter(page => !state.unpublishList.includes(page.id));
    state.unpublishList = [];
    state.isUsingWebSocket = undefined;

    return state;
  },
  [mutationTypes.SET_IS_USING_WEB_SOCKET](state: UnpublishState, value: boolean) {
    state.isUsingWebSocket = value;

    return state;
  },
  [mutationTypes.CANCEL_CAMPAIGN_STATUS](state: UnpublishState, campaignId: number) {
    state.waitingCampaignList = state.waitingCampaignList.filter(id => id !== campaignId);

    return state;
  },
  [mutationTypes.REMOVE_CAMPAIGN_STATUS](state: UnpublishState, campaignId: number) {
    state.publishedPage = state.publishedPage.map(page => {
      if (page.isInCampaign === campaignId) {
        page.isInCampaign = 0;
      }

      return page;
    });
    state.waitingCampaignList = state.waitingCampaignList.filter(id => id !== campaignId);

    return state;
  },
  [mutationTypes.ADD_CAMPAIGN](state: UnpublishState, campaignId: number) {
    state.waitingCampaignList = [...state.waitingCampaignList, campaignId];

    return state;
  }
}

export default mutations;
